import { useCallback } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { useDispatch, useSelector } from "react-redux";
import { useResourceSelectorContext } from "../components/ResourceSelector/ResourceSelector";

import { goToCatalog } from "../ducks/location/location";
import { getCurrentTab, getLocationQuery } from "../ducks/location/selectors";

const isTabValid = (tab: ResourceTypeLink): boolean => Object.values(ResourceTypeLink).includes(tab);

export const useResourceType = (): [ResourceTypeLink, (type: ResourceTypeLink) => void] => {
  const dispatch = useDispatch();
  const locationTab = useSelector(getCurrentTab);
  const { addFromCatalog, openMap } = useSelector(getLocationQuery);
  const resourceType = isTabValid(locationTab) ? locationTab : ResourceTypeLink.Project;
  const updateResourceType = useCallback(
    (tab: ResourceTypeLink) => dispatch(goToCatalog({ tab }, { addFromCatalog, openMap })),
    [dispatch, addFromCatalog, openMap],
  );
  const { active: resourceSelectorActive, resourceType: selectorResourceType } = useResourceSelectorContext();

  return [resourceSelectorActive ? selectorResourceType : resourceType, updateResourceType];
};
